import { useQuery, UseQueryResult } from "react-query";
import * as Redux from "react-redux";
import { useSearchParams } from "react-router-dom";

import { convertUserStateAndRestoreToRoute } from "client/context/router-context";
import { logAmplitudeEvent } from "client/lib/amplitude/metrics";
import * as UserService from "client/services/user";
import { errorActions, formCompletionActions, userActions } from "client/store";
import { UserStateResponse } from "client/types";

export const useUserState = (): UseQueryResult<UserStateResponse, Error> => {
  const dispatch = Redux.useDispatch();
  const [searchParams, _] = useSearchParams();

  return useQuery<UserStateResponse, Error>(
    "user-state",
    UserService.getUserState,
    {
      onSuccess: ({ email, formCompletedState, userState }) => {
        // We track merchants who are arriving to MOP surcessfully through onboarding or verify email link
        // through query parameters with param key ="ol_src"
        // Fire off Amplitude event if source is onboarding link or verify email link
        if (searchParams.has("ol_src")) {
          if (searchParams.get("ol_src") === "obl") {
            logAmplitudeEvent("LOGIN_LIFECYCLE", "clicked_onboarding_link");
          } else if (searchParams.get("ol_src") === "vel") {
            logAmplitudeEvent("LOGIN_LIFECYCLE", "clicked_verify_email_link");
          }
        }
        if (userState) {
          dispatch(userActions.setUserState(userState));
        }
        if (formCompletedState) {
          dispatch(formCompletionActions.setFormCompletion(formCompletedState));
        }
        if (email) {
          dispatch(userActions.setEmail(email));
        }
        const route = convertUserStateAndRestoreToRoute({
          formCompletedState,
          userState,
          onboardingStatus: undefined,
        });
        /**
         * Context on why were adding login loading here - the app always loads the login page initially and then fires a request to see where the merchant should go based on this request response. We need a way to know whether they land on login page and don't get rerouted.
         */
        if (!route) {
          logAmplitudeEvent("REDESIGN_SIGN_UP", "loaded_login_form");
        }
      },
      onError(err) {
        dispatch(errorActions.setError(err.message));
      },
    }
  );
};
